import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  get_card_products,
  delete_card_product,
  messageClear,
  quantity_inc,
  quantity_dec,
} from "../store/reducers/cardReducer";
import toast from "react-hot-toast";
import { NumericFormat } from "react-number-format";

const Card = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const {
    card_products,
    successMessage,
    price,
    buy_product_item,
    shipping_fee,
    outofstock_products,
  } = useSelector((state) => state.card);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(get_card_products(userInfo.id));
  }, [dispatch, userInfo.id]);

  const redirect = () => {
    navigate("/shipping", {
      state: {
        products: card_products,
        price: price,
        shipping_fee: shipping_fee,
        items: buy_product_item,
      },
    });
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
      dispatch(get_card_products(userInfo.id));
    }
  }, [successMessage, dispatch, userInfo.id]);

  const inc = (quantity, stock, card_id) => {
    const temp = quantity + 1;
    if (temp <= stock) {
      dispatch(quantity_inc(card_id));
    }
  };

  const dec = (quantity, card_id) => {
    const temp = quantity - 1;
    if (temp > 0) {
      dispatch(quantity_dec(card_id));
    }
  };

  return (
    <div>
      <Header />
      <section className='bg-[url("https://diarcel.com/images/banner/shop.png")] h-[220px] bg-cover bg-no-repeat relative bg-left'>
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Carrito de Compras </h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Inicio</Link>
                <span className="pt-1">
                  <IoIosArrowForward />
                </span>
                <span>Carrito </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#eeeeee]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16">
          {card_products.length > 0 || outofstock_products.length > 0 ? (
            <div className="flex flex-wrap">
              <div className="w-full md:w-[67%]">
                <div className="pr-0 md:pr-3">
                  <div className="flex flex-col gap-3">
                    <div className="bg-white p-4 rounded-md">
                      <h2 className="text-md text-green-500 font-semibold">
                        Número de Items ({card_products.length})
                      </h2>
                    </div>

                    {card_products.map((p, i) => (
                      <div
                        className="flex bg-white p-4 flex-col gap-2 rounded-md"
                        key={i}
                      >
                        <div className="flex justify-start items-center">
                          <h2 className="text-md text-slate-600 font-bold">
                            {p.shopName}
                          </h2>
                        </div>

                        {p.products.map((pt, i) => (
                          <div className="my-2 w-full flex flex-wrap" key={i}>
                            {/* Product Info Section */}
                            <div className="flex flex-wrap sm:w-full w-full md:w-7/12 gap-2">
                              <div className="flex gap-2 justify-start items-center">
                                <img
                                  className="w-[80px] h-[80px] rounded-md cursor-pointer"
                                  src={pt.productInfo.images[0]}
                                  alt=""
                                  onClick={() =>
                                    navigate(
                                      `/product/details/${pt.productInfo.slug}`
                                    )
                                  }
                                />
                                <div className="pr-4 text-slate-600">
                                  <h2 className="text-md font-semibold">
                                    {pt.productInfo.name}
                                  </h2>
                                  <span className="text-sm">
                                    Brand: {pt.productInfo.brand}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Pricing and Controls Section */}
                            <div className="flex flex-col sm:flex-row justify-between w-full text-slate-600">
                              {/* Pricing Section */}
                              <div className="sm:w-full w-1/2 sm:pl-0">
                                <h2 className="text-lg">
                                  <NumericFormat
                                    displayType="text"
                                    value={(
                                      pt.productInfo.price -
                                      (pt.productInfo.price *
                                        pt.productInfo.discount) /
                                        100
                                    ).toFixed(2)}
                                    placeholder="Precio"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix={"L "}
                                    allowNegative={false}
                                  />
                                </h2>

                                {pt.productInfo.discount ? (
                                  <>
                                    <div>
                                      <NumericFormat
                                        className="line-through text-red-400"
                                        displayType="text"
                                        value={pt.productInfo.price}
                                        placeholder="Precio"
                                        thousandSeparator=","
                                        decimalScale={2}
                                        fixedDecimalScale
                                        prefix={"L "}
                                        allowNegative={false}
                                      />
                                    </div>
                                    <span className="text-orange-500">
                                      Rebaja{" "}
                                      {pt.productInfo.discount.toFixed(2)}%
                                    </span>
                                  </>
                                ) : null}
                              </div>

                              {/* Quantity and Buttons Section */}
                              <div className="flex flex-col sm:gap-2 sm:w-full w-1/2 sm:items-end mt-2 sm:mt-0">
                                <div className="flex bg-slate-200 h-[40px] justify-center items-center text-xl rounded-md">
                                  <button
                                    onClick={() => dec(pt.quantity, pt._id)}
                                    className="px-3 cursor-pointer hover:bg-slate-600 hover:text-white active:bg-slate-800 rounded-md"
                                  >
                                    -
                                  </button>
                                  <div className="px-3">{pt.quantity}</div>
                                  <button
                                    onClick={() =>
                                      inc(
                                        pt.quantity,
                                        pt.productInfo.stock,
                                        pt._id
                                      )
                                    }
                                    className="px-3 cursor-pointer hover:bg-slate-600 hover:text-white active:bg-slate-800 rounded-md"
                                  >
                                    +
                                  </button>
                                </div>
                                <button
                                  onClick={() =>
                                    dispatch(delete_card_product(pt._id))
                                  }
                                  className="mt-2 sm:mt-0 px-5 py-[6px] text-white rounded-md shadow-md hover:shadow-red-500/50 hover:shadow-lg bg-red-500"
                                >
                                  Eliminar
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}

                    {outofstock_products.length > 0 && (
                      <div className="flex flex-col gap-3">
                        <div className="bg-white p-4 rounded-md">
                          <h2 className="text-md text-red-500 font-semibold">
                            Fuera de Stock ({outofstock_products.length})
                          </h2>
                        </div>

                        {outofstock_products.map((p, i) => (
                          <div
                            className="flex bg-white p-4 flex-col gap-2 rounded-md"
                            key={i}
                          >
                            {p.products.map((pt, i) => (
                              <div
                                className="my-2 w-full flex flex-wrap"
                                key={i}
                              >
                                {/* Product Info Section */}
                                <div className="flex flex-wrap sm:w-full w-full md:w-7/12 gap-2">
                                  <div className="flex gap-2 justify-start items-center">
                                    <img
                                      className="w-[80px] h-[80px] rounded-lg cursor-pointer"
                                      src={pt.productInfo.images[0]}
                                      alt=""
                                      onClick={() =>
                                        navigate(
                                          `/product/details/${pt.productInfo.slug}`
                                        )
                                      }
                                    />
                                    <div className="pr-4 text-slate-600">
                                      <h2 className="text-md font-semibold">
                                        {pt.productInfo.name}
                                      </h2>
                                      <span className="text-sm">
                                        Marca: {pt.productInfo.brand}
                                      </span>
                                      <p className="text-red-500 text-sm font-semibold">
                                        Fuera de Stock
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/* Pricing Section */}
                                <div className="flex flex-col sm:flex-row justify-between w-full text-slate-600">
                                  <div className="sm:w-full w-1/2 sm:pl-0">
                                    <h2 className="text-lg text-gray-400">
                                      <NumericFormat
                                        displayType="text"
                                        value={(
                                          pt.productInfo.price -
                                          (pt.productInfo.price *
                                            pt.productInfo.discount) /
                                            100
                                        ).toFixed(2)}
                                        placeholder="Precio"
                                        thousandSeparator=","
                                        decimalScale={2}
                                        fixedDecimalScale
                                        prefix={"L "}
                                        allowNegative={false}
                                      />
                                    </h2>

                                    {pt.productInfo.discount ? (
                                      <>
                                        <div>
                                          <NumericFormat
                                            className="line-through text-red-400"
                                            displayType="text"
                                            value={pt.productInfo.price}
                                            placeholder="Precio"
                                            thousandSeparator=","
                                            decimalScale={2}
                                            fixedDecimalScale
                                            prefix={"L "}
                                            allowNegative={false}
                                          />
                                        </div>
                                        <span className="text-orange-500">
                                          Rebaja{" "}
                                          {pt.productInfo.discount.toFixed(2)}%
                                        </span>
                                      </>
                                    ) : null}
                                  </div>
                                  <div className="flex flex-col sm:gap-2 sm:w-full w-1/2 sm:items-end mt-2 sm:mt-0">
                                    <button
                                      onClick={() =>
                                        dispatch(delete_card_product(pt._id))
                                      }
                                      className="mt-2 sm:mt-0 px-5 py-[6px] text-white rounded-md shadow-md hover:shadow-red-500/50 hover:shadow-lg bg-red-500"
                                    >
                                      Eliminar
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="w-full md:w-[33%] mt-3 md:mt-0">
                <div className="pl-0 md:pl-3">
                  {card_products.length > 0 && (
                    <div className="bg-white p-3 text-slate-600 flex flex-col gap-3 rounded-md">
                      <h2 className="text-xl font-bold">Resúmen de tu Orden</h2>
                      <div className="flex justify-between items-center">
                        <span>{buy_product_item} Items </span>
                        <NumericFormat
                          displayType="text"
                          value={price}
                          placeholder="Precio"
                          thousandSeparator=","
                          decimalScale={2}
                          fixedDecimalScale
                          prefix={"L "}
                          allowNegative={false}
                        />
                      </div>
                      <div className="flex justify-between items-center">
                        <span>Precio por envio </span>
                        <NumericFormat
                          displayType="text"
                          value={shipping_fee}
                          placeholder="Precio"
                          thousandSeparator=","
                          decimalScale={2}
                          fixedDecimalScale
                          prefix={"L "}
                          allowNegative={false}
                        />
                      </div>
                      <div className="flex gap-2 rounded-md">
                        <input
                          className="w-full px-3 py-2 border border-slate-200 outline-0 focus:border-green-500 rounded-md"
                          type="text"
                          placeholder="Ingresar cupón"
                        />
                        <button className="px-5 py-[1px] bg-[#059473] text-white rounded-md uppercase text-sm hover:shadow-lg hover:shadow-green-500/50">
                          Aplicar
                        </button>
                      </div>

                      <div className="flex justify-between items-center">
                        <span>Total</span>
                        <span className="text-lg">
                          <NumericFormat
                            displayType="text"
                            value={price + shipping_fee}
                            placeholder="Precio"
                            thousandSeparator=","
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={"L "}
                            allowNegative={false}
                          />
                        </span>
                      </div>
                      <button
                        onClick={redirect}
                        className="px-5 py-[6px] rounded-md hover:shadow-blue-500/50 hover:shadow-lg bg-blue-500 text-sm text-white uppercase "
                      >
                        Continuar a Checkout ({buy_product_item})
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center gap-5">
              <h2 className="text-xl text-slate-600 font-bold">
                No hay productos en el carrito
              </h2>
              <Link
                className="px-10 py-5 bg-indigo-500 text-white rounded-md"
                to="/shops"
              >
                {" "}
                Ir a la Tienda
              </Link>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Card;
